import { useContext } from 'react';
import { useRouteError } from 'react-router-dom';
import { Context } from '../../context/Context';

const ErrorPage = () => {
  const error = useRouteError();
  const { state } = useContext(Context);
  const lang = state?.lang || 'ES';

  const copy = {
    title: lang === 'ES' ? 'Algo ha salido mal, por favor' : 'Something went wrong, please',
    link: lang === 'ES' ? 'contáctese' : 'contact',
    tail:
      lang === 'ES'
        ? 'con el desarrollador de esta aplicación.'
        : 'the developer of this application.',
  };
  return (
    <div className='errorPage'>
      {copy.title}{' '}
      <a href='https://wa.me/573152059991' target='_blank' rel='noreferrer'>
        &nbsp;{copy.link}&nbsp;
      </a>{' '}
      {copy.tail}
      <div className='errorPage__code'>
        <h5>{error?.message}</h5>
        <p>{error?.stack}</p>
      </div>
    </div>
  );
};

export default ErrorPage;
